import { useState } from "react";
import { MessageCircle, X } from "lucide-react";

const WHATSAPP_NUMBER = "905453249892";
const PRESET_MESSAGE = "Merhaba, adalardatatil.com üzerinden ulaşıyorum. Bilgi almak istiyorum.";

export default function WhatsAppFab() {
  const [open, setOpen] = useState(false);

  const buildUrl = (text) => `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;

  const quick = [
    { label: "Feribot rezervasyonu", msg: "Merhaba, feribot rezervasyonu yapmak istiyorum." },
    { label: "Otel rezervasyonu", msg: "Merhaba, otel rezervasyonu için bilgi almak istiyorum." },
    { label: "Tur bilgisi", msg: "Merhaba, turlar hakkında bilgi almak istiyorum." },
    { label: "Vize işlemleri", msg: "Merhaba, vize başvurusu için bilgi almak istiyorum." },
  ];

  return (
    <>
      {open && (
        <div className="fixed bottom-24 right-6 z-50 w-80 bg-white border border-[hsl(var(--border))] shadow-2xl overflow-hidden" data-testid="wa-fab-panel">
          <div className="bg-[#25D366] text-white p-4 flex items-center justify-between">
            <div className="flex items-center gap-2">
              <MessageCircle className="w-5 h-5" />
              <div>
                <div className="font-medium">Adalardatatil</div>
                <div className="text-xs opacity-90">Online</div>
              </div>
            </div>
            <button onClick={() => setOpen(false)} aria-label="Kapat" data-testid="wa-fab-close"><X className="w-5 h-5" /></button>
          </div>
          <div className="p-4 space-y-2 bg-[#ECE5DD] max-h-72 overflow-y-auto">
            <div className="bg-white p-3 text-sm shadow-sm rounded">
              👋 Merhaba! Size nasıl yardımcı olabiliriz?
            </div>
            {quick.map((q, i) => (
              <a key={`wa-quick-${i}`} href={buildUrl(q.msg)} target="_blank" rel="noopener noreferrer"
                className="block bg-white p-2.5 text-sm hover:bg-[#dcf8c6] transition shadow-sm rounded border-l-2 border-[#25D366]"
                data-testid={`wa-quick-${i}`}>
                {q.label} →
              </a>
            ))}
          </div>
          <a href={buildUrl(PRESET_MESSAGE)} target="_blank" rel="noopener noreferrer"
            className="block bg-[#25D366] hover:bg-[#1ebe57] text-white text-center py-3 font-medium transition"
            data-testid="wa-fab-open-chat">
            WhatsApp'ta Aç
          </a>
        </div>
      )}
      <button onClick={() => setOpen(!open)}
        className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1ebe57] text-white shadow-lg flex items-center justify-center transition hover:scale-110"
        aria-label="WhatsApp"
        data-testid="wa-fab-btn">
        {open ? <X className="w-6 h-6" /> : <MessageCircle className="w-7 h-7" />}
      </button>
    </>
  );
}
